export default __webpack_public_path__ + "static/media/mobile9.97d8c44b.jfif";